import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthservicesService } from '../services/authservices.service';

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  record
  completeReg
  constructor(
    private router: Router,
    private authenticationService: AuthservicesService
  ) {
    this.record = JSON.parse(localStorage.getItem('requestToken'));
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentUser = this.authenticationService.currentUserValue;
    this.completeReg = JSON.parse(localStorage.getItem('completeReg'));


    if (this.record) {
      return true
    }
    if (currentUser) {

        return true;
    }
    this.router.navigate(["/login"]);
    return false;
  }
}
